import React, { useCallback } from 'react';
import TStrings from './Grid.i18n';

type ClickableEventRowProps = {
    id?: number;
    value?: string;
    onClick?: (event: { id: number, type?: string }) => void;
    fallbackValue?: string;
    type?: string,
};
const ClickableEventRow: React.FC<ClickableEventRowProps> = ({
    value = '',
    id,
    onClick,
    fallbackValue = '',
    type
}) => {
    const handleClick = useCallback(() => {
        if (onClick && id) {
            onClick({ id, type: type || undefined });
        }
    }, [onClick, id]);

    if (!id || !onClick) {
        return value || fallbackValue;
    }

    return (
        <div className="flex grow items-center">
            {value && <div>{value}</div>}
            <div
                className="flex pl-2 text-blue-500 cursor-pointer items-center"
                onClick={handleClick}
            >
                <div className="flex text-sm">
                    {TStrings.EVENT_CLICK_BUTTON_TITLE}
                </div>
                <div className="flex text-xl px-2">&#8599;</div>
            </div>
        </div>
    );
};
export default ClickableEventRow;
